import React from "react";
import { Field, reduxForm } from "redux-form";
import StandardTextField from "Utils/redux_form_inputs/StandardTextField";
import Validator from "HelperFunctions/validator";
import { setErrors } from "Actions";

const validations = {
  password: {
    required: {
      value: true,
      message: "Password is required"
    }
  }
};

// The signed-in change (Profile) must prove the current password; the emailed reset link does not. TD1-10770.
const currentPasswordValidations = {
  ...validations,
  current_password: {
    required: {
      value: true,
      message: "Current password is required"
    }
  }
};

const PasswordResetForm = props => {
  const { handleSubmit, pristine, submitting, requireCurrentPassword } = props;
  return (
    <form onSubmit={handleSubmit} className="form">
      <div className="fields">
        {requireCurrentPassword && (
          <Field
            name="current_password"
            component={StandardTextField}
            type="password"
            placeholder="Current Password"
          />
        )}
        <Field
          name="password"
          component={StandardTextField}
          type="password"
          placeholder="New Password"
        />
        <Field
          name="password_confirm"
          component={StandardTextField}
          type="password"
          placeholder="Retype New Password"
        />
      </div>
      <div className="actions">
        <button
          className="full"
          type="submit"
          disabled={pristine || submitting}
        >
          Reset Password
        </button>
      </div>
    </form>
  );
};
export default reduxForm({
  form: "PasswordReset", // a unique identifier for this form
  validate: (values, props) =>
    Validator(props.requireCurrentPassword ? currentPasswordValidations : validations)(values),
  onSubmitFail: (errors, dispatch, submitError, props) => {
    if (errors) {
      dispatch(setErrors(errors));
    }
  }
})(PasswordResetForm);
